export const mhBaseUrl = process.env.REACT_APP_MH_BASE_URL;
export const warehouseBaseUrl = process.env.REACT_APP_WAREHOUSE_BASE_URL;
export const courierBaseUrl = process.env.REACT_APP_COURIER_BASE_URL;
export const getirMhBaseUrl = process.env.REACT_APP_GETIR_MH_BASE_URL;

export const baseUrl = (role) => {
  const roles = {
    mh: mhBaseUrl,
    picker: warehouseBaseUrl,
    courier: courierBaseUrl,
    getirMh: getirMhBaseUrl,
  };

  return roles[role] || mhBaseUrl;
};

export const Roles = {
  MH: "mh",
  PICKER: "picker",
  COURIER: "courier",
  GETIR_MH: "getirMh",
};

export const orderStatus = {
  CREATED: "CREATED",
  PREPARED: "PREPARED",
  CANCELLED: "CANCELLED",
  RECEIVED: "RECEIVED",
  ON_DELIVERY: "ON_DELIVERY",
  DELIVERED: "DELIVERED",
};

export const currentRole = localStorage.getItem("role");

export const MIN_BASKET_VALUE = 25;
export const DISCOUNT_PERCENTAGE = 10;

export const DEFAULT_LANGUAGE = "tr";
